import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'WarRoomSignUpMixin',
  methods: {
    async openWarRoomSignUpModal(params: Record<string, any> = {}) {
      const newQuery = Object.assign({}, this.$route.query, {
        dynamic_modal: this.$constants.dynamicModals.SIGN_UP_MODAL,
        ...params,
      });

      await this.$router.replace({ query: newQuery });
    },
  },
});
